__turbopack_context__.v({
  "globe": "LocaleSwitcher-module-scss-module__juwsWG__globe",
  "knob": "LocaleSwitcher-module-scss-module__juwsWG__knob",
  "knobEnd": "LocaleSwitcher-module-scss-module__juwsWG__knobEnd",
  "option": "LocaleSwitcher-module-scss-module__juwsWG__option",
  "optionOn": "LocaleSwitcher-module-scss-module__juwsWG__optionOn",
  "switcher": "LocaleSwitcher-module-scss-module__juwsWG__switcher",
  "track": "LocaleSwitcher-module-scss-module__juwsWG__track",
});
